import Icon from '../components/Icon.vue'

Icon.register({
  'money-bill': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32h-576c-17.7 0-32-14.3-32-32v-320c0-17.7 14.3-32 32-32h576zM48 400h64c0-35.3-28.7-64-64-64v64zM48 176c35.3 0 64-28.7 64-64h-64v64zM320 352c44.2 0 80-43 80-96 0-53-35.8-96-80-96s-80 43-80 96c0 53 35.8 96 80 96zM592 400v-64c-35.3 0-64 28.7-64 64h64zM592 176v-64h-64c0 35.3 28.7 64 64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-bill.js
// module id = 1578
// module chunks = 0